import { render } from "./modules.vue?vue&type=template&id=09da21ef&scoped=true"
import script from "./modules.vue?vue&type=script&lang=js"
export * from "./modules.vue?vue&type=script&lang=js"

import "./modules.vue?vue&type=style&index=0&id=09da21ef&scoped=true&lang=css"

import exportComponent from "E:\\项目\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09da21ef"]])

export default __exports__